import type React from "react";
import { useState } from "react";

import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import type { MedicalNoteAddendum } from "api/models/MedicalNoteAddendum";

import { AddendumForm, AddendumList } from ".";

interface Props {
  careEventId: number;
  medical_note_addenda?: MedicalNoteAddendum[];
}

export const Addenda: React.FC<Props> = ({ careEventId, medical_note_addenda }) => {
  const [formTriggerHeader, setFormTriggerHeader] = useState(false);
  const { t } = useTranslation();

  const isAddendaPopulated = (medical_note_addenda && medical_note_addenda.length > 0) ?? false;

  return (
    <AddendaSection data-testid="record-note-addenda" $hasBackground={isAddendaPopulated}>
      {(formTriggerHeader || isAddendaPopulated) && (
        <Typography variant="body_bold" mb={1}>
          {t("patients.notes.sections.addenda.header")}
        </Typography>
      )}

      {isAddendaPopulated && <AddendumList medical_note_addenda={medical_note_addenda} />}

      <Box maxWidth={400}>
        <AddendumForm careEventId={careEventId} setFormTriggerHeader={setFormTriggerHeader} />
      </Box>
    </AddendaSection>
  );
};

const AddendaSection = styled.div<{ $hasBackground: boolean }>`
  background: ${({ theme, $hasBackground }) => $hasBackground && theme.colors.redesign.db1};
  margin-top: ${({ $hasBackground }) => $hasBackground && "25px"};
  padding: 24px 16px;
  border-radius: 8px;
`;
